import '.a2{position:fixed;}.ssr-plugin'
import '.cq{top:0;}.ssr-plugin'
import '.av{left:0px;}.ssr-plugin'
import '.aw{right:0px;}.ssr-plugin'
import '.g7{bottom:0px;}.ssr-plugin'
import '.ht{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.hu{z-index:998;}.ssr-plugin'
import '.hv{transition:opacity 0.3s ease;}.ssr-plugin'
import '.w{height:100vh;}.ssr-plugin'
import '.a6{width:100%;}.ssr-plugin'
import '.af{background-color:var(--shades-white);}.ssr-plugin'
import '.hw{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.hx{z-index:999;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.a7{justify-content:space-between;}.ssr-plugin'
import '.bv{padding:1.5rem;}.ssr-plugin'
import '.hy{border-bottom:1px solid var(--gray-border);}.ssr-plugin'
import '.br{flex-shrink:0;}.ssr-plugin'
import '.bt{flex:1;}.ssr-plugin'
import '.ag{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="a2 cq av aw g7 ht hu hv"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="a2 cq w a6 af hw hx a e"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="a f a7 bv hy br"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="bt ag bv"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
